// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__2EYdF","buttonActive":"Navigation_buttonActive__3x7kb","buttonNonActive":"Navigation_buttonNonActive__35Yt_"};